<script>
export default {
  name: '',
  mounted() {
    this.$nextTick(() => {
      window.location.href = '/';
    });
  },
};
</script>
